import React, { Component } from "react";
import ClearFilterButton from "../../components/ClearFilterButton.js";
import {
  loading,
  alert,
  NavbarAdmin,
  Pagination,
  Modal,
  Select,
  DatePicker,
  GET,
  POST,
  GET_FILE,
  saveAs,
  profile,
  currentLang,
  t,
} from "../../components/CustomComponent.js";
import { fmtDate, fmtDateTime, pruneParams, hasPermission } from "../../utils/timeTracking.js";
import { readDepartmentFilter, departmentFilterOptions, departmentFilterValue, departmentFilterPatch, EMPTY_DEPARTMENT_FILTER } from "../../utils/departmentFilter.js";
import "../../assets/css/warranty-expiry.css";
import { formatNumber } from "../../utils/formatting";

const PAGE_SIZE = 50;
const Q_DEBOUNCE_MS = 400;
const BUCKETS = ["ovd", "p1", "p7", "p14", "p30"];
// สี tag / KPI ของช่วงวัน PM ใช้ชุดเดียวกับรายงานประกัน/ไส้กรอง (class ใน warranty-expiry.css)
const BUCKET_CLASS = { ovd: "ovd", p1: "d7", p7: "d30", p14: "d60", p30: "d90" };
const BANNER_COLORS = {
  ovd: ["#F9DADA", "#A61B1B"],
  d7: ["#FDECEC", "#D64545"],
  d30: ["#FFEBDD", "#D9620B"],
  d60: ["#FFF4DC", "#B86E0A"],
  d90: ["#E8EDFF", "#2643B8"],
  done: ["#E3F5EA", "#1F8A4C"],
  plan: ["#FFF4DC", "#B86E0A"],
};
const STATUS_FILTERS = ["open", "no_wo", "wo_overdue", "wo_created", "postponed", "all"];
const STATE_CLASS = { no_wo: "wx-fu-none", wo_created: "wx-fu-ok", wo_overdue: "wx-fu-ovd", done: "wx-fu-ok" };
// ข้อความ 403 จาก backend เมื่อเปิดแผนกที่ไม่มีสิทธิ์: "คุณไม่มีสิทธิ์ดูแผนก <code>"
const NO_DEPARTMENT_PATTERNS = ["ไม่มีสิทธิ์ดูแผนก", "ไม่มีสิทธิ์ดู BU"];
// สีการ์ด KPI ตามช่วงวัน [พื้นหลัง, ตัวเลข] (โทนเดียวกับ BANNER_COLORS)
const KPI_COLORS = { ovd: BANNER_COLORS.ovd, p1: BANNER_COLORS.d7, p7: BANNER_COLORS.d30, p14: BANNER_COLORS.d60, p30: BANNER_COLORS.d90 };
// ตัวกรองสถานะของปฏิทิน (กรองฝั่ง client จาก state ของแต่ละวง)
const CAL_STATUS_MATCH = {
  open: (d) => d.state === "no_wo" || d.state === "wo_overdue",
  no_wo: (d) => d.state === "no_wo",
  wo_overdue: (d) => d.state === "wo_overdue",
  wo_created: (d) => d.state === "wo_created",
  postponed: (d) => d.postpone_count > 0,
  all: () => true,
};

const fill = (text, values) => Object.keys(values).reduce((acc, k) => acc.replace(`{${k}}`, values[k]), text);

const monthLabels = () => {
  const locale = currentLang() === "en" ? "en-GB" : "th-TH";
  return Array.from({ length: 12 }, (_, i) => new Date(2000, i, 1).toLocaleDateString(locale, { month: "short" }));
};

// หน้า "แจ้งเตือนแผน PM" - field ตรงกับ SNAPA-Backend modules/admin/pm-alert (1 แถว = 1 ครั้งตามแผน = 1 WO)
//   GET  admin/pm-alert                  -> data={rows,kpi,meta} + pagination
//   GET  admin/pm-alert/calendar         -> {year, summary, plans[{months:[12 x dots]}]}
//   GET  admin/pm-alert/:wo_uid          -> row + occurrences + postpone_logs + alerts + actions
//   POST admin/pm-alert/:wo_uid/postpone -> {row}   POST admin/pm-alert/:wo_uid/create-wo -> {row, work_order}
//   GET  admin/pm-alert/export           -> xlsx (GET_FILE)
// ลิงก์จากอีเมล: ?bu=BU05&open=<wo uid> -> กรอง BU + เปิด Modal ครั้งนั้น · ?department_uid=<uid> กรองแผนก
export default class AdminPmAlert extends Component {
  constructor(props) {
    super(props);
    const query = new URLSearchParams(window.location.search);
    this.initial_open = query.get("open") || "";
    const bucket = query.get("bucket");
    this.canExport = hasPermission(profile, "pm_alert.export");
    this.canPostpone = hasPermission(profile, "pm_alert.postpone");
    this.canCreateWo = hasPermission(profile, "pm_alert.create_wo");
    this.q_timer = null;
    this.state = {
      view: "list", // list | cal
      ...readDepartmentFilter(query),
      filter_customer_uid: "",
      filter_status: "open",
      filter_frequency: "",
      filter_technician_uid: "",
      filter_q: "",
      filter_bucket: BUCKETS.includes(bucket) ? bucket : "",
      sort_by: "days_left",
      sort_dir: "asc",

      rows: [],
      kpi: null,
      meta: null,
      count: 0,
      page: 1,
      loaded: false,
      forbidden: "",

      year: new Date().getFullYear(),
      calendar: null,

      detail: null,
      form: null, // { action: ""|"wo"|"rs", new_date, reason, note }
      form_error: "",
      created_wo: null, // {uid, number} หลังสร้าง WO สำเร็จ
      saving: false,
    };
  }

  componentDidMount() {
    loading(false);
    this.Get(1).then(() => {
      if (this.initial_open) this.OpenDetail(this.initial_open);
    });
  }

  componentWillUnmount() {
    clearTimeout(this.q_timer);
  }

  commonParams = () => {
    const { filter_bu, filter_department_uid, filter_customer_uid, filter_frequency, filter_technician_uid, filter_q, filter_bucket } = this.state;
    return pruneParams({
      bu_code: filter_bu,
      department_uid: filter_department_uid,
      customer_uid: filter_customer_uid,
      frequency: filter_frequency,
      technician_uid: filter_technician_uid,
      q: filter_q.trim(),
      bucket: filter_bucket,
    });
  };

  buildParams = () => {
    const { filter_status, sort_by, sort_dir } = this.state;
    return { ...this.commonParams(), status: filter_status, sort_by, sort_dir };
  };

  Get = async (page = 1) => {
    loading(true);
    const result = await GET("admin/pm-alert", { ...this.buildParams(), page, limit: PAGE_SIZE });
    if (result?.status) {
      const rows = result.data?.rows || [];
      this.setState({
        rows,
        kpi: result.data?.kpi || null,
        meta: result.data?.meta || null,
        count: result.pagination?.count ?? rows.length,
        page,
        loaded: true,
        forbidden: "",
      });
      if (this.state.view === "cal") await this.GetCalendar();
      loading(false);
      return;
    }
    loading(false);
    const message = result?.message || "";
    this.setState({
      rows: [],
      kpi: null,
      count: 0,
      page: 1,
      calendar: null,
      loaded: true,
      forbidden: typeof message === "string" && NO_DEPARTMENT_PATTERNS.some((p) => message.includes(p)) ? message : "",
    });
  };

  GetCalendar = async () => {
    const result = await GET("admin/pm-alert/calendar", { ...this.commonParams(), year: this.state.year });
    this.setState({ calendar: result?.status ? result.data : null });
  };

  SetView = (view) => {
    this.setState({ view }, async () => {
      if (view === "cal") {
        loading(true);
        await this.GetCalendar();
        loading(false);
      }
    });
  };

  ShiftYear = (delta) => {
    this.setState({ year: this.state.year + delta }, async () => {
      loading(true);
      await this.GetCalendar();
      loading(false);
    });
  };

  SetFilter = (patch) => this.setState(patch, () => this.Get(1));

  SetQ = (value) => {
    this.setState({ filter_q: value });
    clearTimeout(this.q_timer);
    this.q_timer = setTimeout(() => this.Get(1), Q_DEBOUNCE_MS);
  };

  ToggleBucket = (key) => this.SetFilter({ filter_bucket: this.state.filter_bucket === key ? "" : key });

  ResetFilter = () => {
    window.history.replaceState(null, "", window.location.pathname);
    this.SetFilter({ ...EMPTY_DEPARTMENT_FILTER, filter_customer_uid: "", filter_status: "open", filter_frequency: "", filter_technician_uid: "", filter_q: "", filter_bucket: "" });
  };

  SortBy = (field) => {
    const { sort_by, sort_dir } = this.state;
    this.SetFilter({ sort_by: field, sort_dir: sort_by === field && sort_dir === "asc" ? "desc" : "asc" });
  };

  Export = async () => {
    loading(true);
    const result = await GET_FILE("admin/pm-alert/export", this.buildParams());
    loading(false);
    if (result?.status && result.blob) {
      saveAs(result.blob, result.fileName || "PM_Alert.xlsx");
    } else {
      alert("", "warning", t("warning"), result?.message || t("wx_export_failed"));
    }
  };

  // action = "wo" | "rs" เลือกวิธีดำเนินการไว้ล่วงหน้า (กดจากปุ่มในตาราง) · keep = โหลดซ้ำหลังบันทึก (คงแผง WO ที่สร้างไว้)
  OpenDetail = async (uid, action = "", keep = false) => {
    loading(true);
    const result = await GET(`admin/pm-alert/${uid}`);
    loading(false);
    if (!result?.status || !result.data) return;
    const a = result.data.actions || {};
    const allowed = (action === "wo" && a.can_create_wo && this.canCreateWo) || (action === "rs" && a.can_postpone && this.canPostpone);
    this.setState((prev) => ({
      detail: result.data,
      form: { action: allowed ? action : "", new_date: "", reason: "", note: "" },
      form_error: "",
      created_wo: keep ? prev.created_wo : null,
    }));
  };

  CloseDetail = () => {
    const query = new URLSearchParams(window.location.search);
    if (query.has("open")) {
      query.delete("open");
      const qs = query.toString();
      window.history.replaceState(null, "", window.location.pathname + (qs ? `?${qs}` : ""));
    }
    this.setState({ detail: null, form: null, form_error: "", created_wo: null });
  };

  RefreshAfterSave = async (uid, keep) => {
    await this.OpenDetail(uid, "", keep);
    await this.Get(this.state.page);
  };

  Submit = async () => {
    const { detail, form } = this.state;
    const a = detail.actions || {};
    if (!form.action) return this.setState({ form_error: t("pa_act_pick") });

    if (form.action === "wo") {
      this.setState({ saving: true, form_error: "" });
      loading(true);
      const result = await POST(`admin/pm-alert/${detail.uid}/create-wo`, {});
      loading(false);
      this.setState({ saving: false });
      if (!result?.status) return this.setState({ form_error: (typeof result?.message === "string" && result.message) || t("wx_load_failed") });
      const wo = result.data?.work_order || null;
      this.setState({ created_wo: wo });
      alert("", "success", t("success"), t("pa_wo_created"));
      await this.RefreshAfterSave(detail.uid, true);
      return;
    }

    const reason = (a.reasons || []).find((r) => r.key === form.reason);
    if (!form.new_date) return this.setState({ form_error: t("pa_rs_need_date") });
    if (!reason) return this.setState({ form_error: t("pa_rs_need_reason") });
    if (reason.requires_note && !form.note.trim()) return this.setState({ form_error: t("pa_rs_need_note") });
    this.setState({ saving: true, form_error: "" });
    loading(true);
    const result = await POST(`admin/pm-alert/${detail.uid}/postpone`, {
      new_date: form.new_date,
      reason: form.reason,
      note: form.note.trim() || undefined,
    });
    loading(false);
    this.setState({ saving: false });
    if (!result?.status) return this.setState({ form_error: (typeof result?.message === "string" && result.message) || t("wx_load_failed") });
    alert("", "success", t("success"), fill(t("pa_rs_saved"), { date: fmtDate(form.new_date) }));
    await this.RefreshAfterSave(detail.uid, false);
  };

  OpenWo = (number) => {
    window.location.href = `/ad/work-orders?search=${encodeURIComponent(number)}`;
  };

  // ---------------------------------------------------------------- render
  renderDays = (row) => {
    const label = row.days_left < 0 ? fill(t("pa_overdue_days"), { n: -row.days_left }) : row.days_left === 0 ? t("pa_today") : fill(t("wx_days_left"), { n: row.days_left });
    return <span className={`d-inline-block text-12 fw-semibold px-2 py-1 rounded-pill text-nowrap wx-t-${BUCKET_CLASS[row.bucket] || "ok"}`}>{label}</span>;
  };

  renderPlanDate = (r) => (
    <div>
      {r.original_date && r.original_date !== r.plan_date ? <div className="wx-strike text-12">{fmtDate(r.original_date)}</div> : null}
      <b className="text-14 text-dark">{fmtDate(r.plan_date)}</b>
    </div>
  );

  renderState = (r) => (
    <div>
      <span className={`fw-semibold text-nowrap ${STATE_CLASS[r.state] || ""}`}>{r.state_label || t(`pa_state_${r.state}`)}</span>
      {r.work_order?.number ? <div className="text-secondary text-12">{r.work_order.number}{r.work_order.status_label ? ` · ${r.work_order.status_label}` : ""}</div> : null}
      {r.postpone_count > 0 ? <div className="text-12 fw-semibold wx-fu-warn">↻ {fill(t("pa_postponed_n"), { n: formatNumber(r.postpone_count) })}</div> : null}
    </div>
  );

  renderLastAlert = (r) => {
    const mode = r.alert_mode;
    return (
      <div className="text-secondary text-12">
        {mode === "stopped" ? t("pa_alert_stopped") : r.last_alert?.label || "-"}
        {mode === "repeat" ? <div className="fw-semibold wx-fu-ovd">{t("pa_alert_repeat")}</div> : null}
      </div>
    );
  };

  renderKpi() {
    const { kpi, filter_bucket } = this.state;
    if (!kpi) return null;
    const card = (key, value, label, colors, onClick, testid) => (
      <div className="col" key={key || "total"} style={{ minWidth: 150 }}>
        <button
          type="button"
          className="card border-0 rounded-4 shadow-sm p-3 h-100 w-100 text-center wx-kpi"
          style={{ backgroundColor: colors ? colors[0] : "#fff", outline: filter_bucket === key ? "2px solid #2A55E5" : "none", outlineOffset: -2 }}
          onClick={onClick}
          data-testid={testid}
        >
          <div className="text-secondary text-12 fw-bold mb-1">{label}</div>
          <div className="fw-bold" style={{ fontSize: "2.6rem", lineHeight: 1.1, color: colors ? colors[1] : "#2A55E5" }}>{value}</div>
        </button>
      </div>
    );
    return (
      <div className="row g-3 mb-4" data-testid="pa-kpis">
        {card("", kpi.total, t("pa_kpi_total"), null, () => this.SetFilter({ filter_bucket: "" }), "pa-kpi-total")}
        {BUCKETS.map((b) => card(b, kpi[b], t(`pa_bucket_${b}`), KPI_COLORS[b], () => this.ToggleBucket(b), `pa-kpi-${b}`))}
      </div>
    );
  }

  renderSortTh = (field, label) => {
    const { sort_by, sort_dir } = this.state;
    return (
      <th className="py-3 border-0 wx-th-sort" onClick={() => this.SortBy(field)}>
        {label} {sort_by === field ? (sort_dir === "asc" ? "▲" : "▼") : ""}
      </th>
    );
  };

  renderTable() {
    const { rows } = this.state;
    return (
      <div className="table-responsive">
        <table className="table table-hover align-middle mb-0" style={{ minWidth: 1100 }}>
          <thead>
            <tr className="text-dark fw-bold text-12 border-bottom border-light">
              {this.renderSortTh("days_left", t("pa_col_days"))}
              {this.renderSortTh("department", t("wx_col_bu"))}
              <th className="py-3 border-0">{t("pa_col_plan")}</th>
              {this.renderSortTh("customer_name", t("wx_col_customer"))}
              <th className="py-3 border-0">{t("pa_col_asset")}</th>
              <th className="py-3 border-0">{t("pa_col_freq")}</th>
              {this.renderSortTh("plan_date", t("pa_col_plan_date"))}
              {this.renderSortTh("technician", t("pa_col_tech"))}
              <th className="py-3 border-0">{t("wx_col_last_alert")}</th>
              <th className="py-3 border-0">{t("pa_col_state")}</th>
              <th className="py-3 border-0" />
            </tr>
          </thead>
          <tbody>
            {!rows.length ? (
              <tr>
                <td colSpan={11} className="text-center text-secondary py-5">
                  {t("pa_empty")}
                  <div><ClearFilterButton className="mt-2" onClick={this.ResetFilter} /></div>
                </td>
              </tr>
            ) : (
              rows.map((r) => (
                <tr key={r.uid} className="border-bottom border-light bg-white pointer" onClick={() => this.OpenDetail(r.uid)} data-testid="pa-row">
                  <td>{this.renderDays(r)}</td>
                  <td className="text-14 text-dark fw-semibold">{[r.department?.code, r.department?.name].filter(Boolean).join(" ") || "-"}</td>
                  <td className="text-14 text-nowrap">
                    <span className="fw-bold text-primary text-decoration-underline">{r.plan_code || "-"}</span>
                    <div className="text-secondary text-12">{fill(t("pa_occurrence"), { n: r.occurrence_no, total: r.occurrence_total })}</div>
                  </td>
                  <td className="text-14 text-dark">{r.customer_name || "-"}<div className="text-secondary text-12">{r.location || ""}</div></td>
                  <td className="text-14 text-dark">{r.asset?.name || "-"}<div className="text-secondary text-12">{r.asset?.code || ""}</div></td>
                  <td className="text-12 text-secondary">{r.frequency || "-"}</td>
                  <td>{this.renderPlanDate(r)}</td>
                  <td className="text-14 text-dark">{r.technician?.name || "-"}</td>
                  <td>{this.renderLastAlert(r)}</td>
                  <td className="text-14 text-nowrap">{this.renderState(r)}</td>
                  <td className="text-nowrap pe-3" onClick={(e) => e.stopPropagation()}>
                    {r.can_create_wo && this.canCreateWo ? (
                      <button type="button" className="btn btn-primary px-3 py-1 rounded-3 text-12 me-1" onClick={() => this.OpenDetail(r.uid, "wo")} data-testid="pa-row-create-wo">{t("pa_create_wo")}</button>
                    ) : null}
                    {r.can_postpone && this.canPostpone ? (
                      <button type="button" className="btn btn-white border px-3 py-1 rounded-3 text-12 me-1" onClick={() => this.OpenDetail(r.uid, "rs")} data-testid="pa-row-postpone">↻ {t("pa_postpone")}</button>
                    ) : null}
                    {!(r.can_create_wo && this.canCreateWo) && !(r.can_postpone && this.canPostpone) ? (
                      <button type="button" className="btn btn-white border border-primary text-primary px-3 py-1 rounded-3 text-12" onClick={() => this.OpenDetail(r.uid)}>{t("wx_detail")}</button>
                    ) : null}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    );
  }

  renderCalendar() {
    const { calendar, year } = this.state;
    const months = monthLabels();
    const match = CAL_STATUS_MATCH[this.state.filter_status] || CAL_STATUS_MATCH.open;
    const plans = (calendar?.plans || [])
      .map((p) => {
        const months = p.months.map((dots) => dots.filter(match));
        return { ...p, months, shown: months.reduce((n, d) => n + d.length, 0) };
      })
      .filter((p) => p.shown > 0);
    const s = calendar?.summary;
    // ปุ่มจัดการ: เปิดครั้งที่ยังไม่เสร็จครั้งแรก (ไม่มี = ครั้งสุดท้าย)
    const manageDot = (p) => {
      const all = p.months.flat();
      return all.find((d) => d.dot !== "done") || all[all.length - 1];
    };
    return (
      <div className="bg-white rounded-4 shadow-sm mb-4 overflow-hidden" data-testid="pa-calendar">
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 px-4 pt-3 pb-2">
          <div className="d-flex align-items-center gap-2">
            <button type="button" className="btn btn-white border px-2 py-1 rounded-3" onClick={() => this.ShiftYear(-1)} aria-label="prev-year">‹</button>
            <b className="text-dark" data-testid="pa-cal-year">{year}</b>
            <button type="button" className="btn btn-white border px-2 py-1 rounded-3" onClick={() => this.ShiftYear(1)} aria-label="next-year">›</button>
            {s ? <span className="text-secondary text-12 ms-2">{fill(t("pa_cal_summary"), { plans: plans.length, occ: plans.reduce((n, p) => n + p.shown, 0) })}</span> : null}
          </div>
          <div className="wx-legend">
            <span><i style={{ background: "#F59E0B" }} />{t("pa_cal_plan")}</span>
            <span><i style={{ background: "#16A34A" }} />{t("pa_cal_done")}</span>
            <span><i style={{ background: "#2563EB", boxShadow: "0 0 0 3px #FDE68A" }} />{t("pa_cal_soon")}</span>
            <span><i style={{ background: "#fff", boxShadow: "inset 0 0 0 2px #2563EB" }} />{t("pa_cal_wo")}</span>
            <span><i style={{ background: "#DC2626" }} />{t("pa_cal_ovd")}</span>
            <span>↻ {t("pa_cal_postponed")}</span>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table align-middle mb-0" style={{ minWidth: 1100 }}>
            <thead>
              <tr className="text-dark fw-bold text-12 border-bottom border-light">
                <th className="py-3 px-4 border-0" style={{ minWidth: 200 }}>{t("pa_col_asset")}</th>
                {months.map((m, i) => <th key={i} className="py-3 text-center border-0">{m}</th>)}
                <th className="py-3 text-center border-0">{t("total")}</th>
                <th className="py-3 text-center border-0">{t("manage_col")}</th>
              </tr>
            </thead>
            <tbody>
              {!plans.length ? (
                <tr><td colSpan={15} className="text-center text-secondary py-5">{t("pa_cal_empty")}</td></tr>
              ) : plans.map((p) => (
                <tr key={p.plan_uid} className="border-bottom border-light" data-testid="pa-cal-row">
                  <td className="px-4 py-2">
                    <div className="fw-bold text-dark text-14">{p.asset?.name || "-"}</div>
                    <div className="text-secondary text-12">{p.customer_name || ""}</div>
                    <div className="text-secondary text-12">{[p.plan_code, p.bu_code || p.department?.code, p.frequency].filter(Boolean).join(" · ")}</div>
                  </td>
                  {p.months.map((dots, i) => (
                    <td key={i} className="text-center">
                      {dots.length ? dots.map((d) => (
                        <button
                          type="button"
                          key={d.wo_uid}
                          className={`wx-dot ${d.dot}`}
                          title={`${fill(t("pa_occurrence_short"), { n: d.occurrence_no })} · ${fmtDate(d.date)}${d.postpone_count > 0 ? ` (${t("pa_cal_postponed_from")} ${fmtDate(d.original_date)})` : ""}`}
                          onClick={() => this.OpenDetail(d.wo_uid)}
                          data-testid="pa-dot"
                        >
                          {d.day}
                          {d.postpone_count > 0 ? <span className="rs">↻</span> : null}
                        </button>
                      )) : <span className="text-secondary text-12">–</span>}
                    </td>
                  ))}
                  <td className="text-center"><span className="badge bg-primary-light text-primary rounded-pill px-2 py-1">{p.shown}</span></td>
                  <td className="text-center">
                    <button type="button" className="btn btn-white border px-3 py-1 rounded-3 text-12 text-nowrap" title={t("wx_detail")} aria-label={t("wx_detail")} onClick={() => manageDot(p) && this.OpenDetail(manageDot(p).wo_uid)} data-testid="pa-cal-manage">{t("wx_detail")}</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  renderActions() {
    const { detail, form, form_error, saving, created_wo } = this.state;
    const a = detail.actions || {};
    const setForm = (patch) => this.setState({ form: { ...form, ...patch }, form_error: "" });
    const woNumber = created_wo?.number || detail.work_order?.number;

    if (created_wo) {
      return (
        <div className="border border-success rounded-3 p-3 mb-4" data-testid="pa-wo-created">
          <div className="text-14 fw-bold text-success mb-1">{t("pa_wo_created")}</div>
          <div className="text-14 text-dark mb-2">{t("pa_wo_number")}: <b>{created_wo.number || "-"}</b></div>
          <div className="d-flex justify-content-end">
            <button type="button" className="btn btn-primary px-4 py-2 rounded-3 fw-bold" onClick={() => this.OpenWo(created_wo.number)} data-testid="pa-open-wo-created">{t("pa_open_wo")} →</button>
          </div>
        </div>
      );
    }

    if (detail.work_order) {
      return (
        <>
          <div className="text-14 fw-bold text-dark mb-2">🔧 {t("pa_wo_title")}</div>
          <div className="border rounded-3 p-3 mb-4">
            <div className="row g-3 text-14">
              <div className="col-md-4"><div className="text-secondary text-12">{t("pa_wo_number")}</div><div className="text-dark">{detail.work_order.number}</div></div>
              <div className="col-md-4"><div className="text-secondary text-12">{t("pa_wo_status")}</div><div className="text-dark">{detail.work_order.status_label || "-"}</div></div>
              <div className="col-md-4"><div className="text-secondary text-12">{t("pa_wo_date")}</div><div className="text-dark">{fmtDate(detail.plan_date)}</div></div>
            </div>
            <div className="text-secondary text-12 mt-2">{t("pa_wo_hint")}</div>
            <div className="d-flex justify-content-end mt-2">
              <button type="button" className="btn btn-white border px-3 py-2 rounded-3 fw-bold" onClick={() => this.OpenWo(woNumber)}>{t("pa_open_wo")}</button>
            </div>
          </div>
        </>
      );
    }

    const showWo = a.can_create_wo && this.canCreateWo;
    const showRs = a.can_postpone && this.canPostpone;
    if (!showWo && !showRs) {
      const reason = a.blocked_reason || a.postpone_blocked_reason;
      return reason ? <div className="text-secondary text-14 mb-4" data-testid="pa-blocked">{reason}</div> : null;
    }
    const reasons = a.reasons || [];
    const currentReason = reasons.find((r) => r.key === form.reason);
    return (
      <>
        <div className="text-14 fw-bold text-dark mb-2">⚡ {t("pa_act_title")}</div>
        <div className="border rounded-3 p-3 mb-4" data-testid="pa-act-form">
          {showWo ? (
            <div className="form-check mb-1">
              <label className="form-check-label text-14 text-dark">
                <input className="form-check-input" type="radio" name="pa-action" checked={form.action === "wo"} onChange={() => setForm({ action: "wo" })} data-testid="pa-act-wo" />
                {t("pa_act_wo")}
              </label>
            </div>
          ) : null}
          {form.action === "wo" ? (
            <div className="ms-4 mb-2 p-2 rounded-3 text-secondary text-12" style={{ background: "#F4F7FE" }}>
              {fill(t("pa_act_wo_hint"), { asset: detail.asset?.code || "", template: detail.checklist_template || "-", tech: detail.technician?.name || "-", date: fmtDate(detail.plan_date) })}
            </div>
          ) : null}
          {showRs ? (
            <div className="form-check mb-1">
              <label className="form-check-label text-14 text-dark">
                <input className="form-check-input" type="radio" name="pa-action" checked={form.action === "rs"} onChange={() => setForm({ action: "rs" })} data-testid="pa-act-rs" />
                ↻ {t("pa_act_rs")}
              </label>
            </div>
          ) : null}
          {a.can_create_wo && a.postpone_blocked_reason && this.canPostpone ? <div className="ms-4 text-12 text-secondary mb-2" data-testid="pa-rs-blocked">{a.postpone_blocked_reason}</div> : null}
          {form.action === "rs" ? (
            <div className="ms-4 mb-2" data-testid="pa-rs-box">
              <div className="row g-3 mb-2">
                <div className="col-md-6">
                  <label className="form-label text-12 text-secondary mb-1">{t("pa_rs_new_date")} *</label>
                  <DatePicker type={currentLang()} className="form-control" value={form.new_date} min={a.min_date || undefined} max={a.max_date || undefined} onChange={(v) => setForm({ new_date: v })} />
                </div>
                <div className="col-md-6" data-testid="pa-rs-reason">
                  <label className="form-label text-12 text-secondary mb-1">{t("pa_rs_reason")} *</label>
                  <Select
                    className="form-control w-100"
                    options={reasons.map((r) => ({ value: r.key, label: r.label }))}
                    value={form.reason}
                    onChange={(v) => setForm({ reason: v || "" })}
                    placeholder={t("pa_rs_reason_ph")}
                  />
                </div>
              </div>
              <div className="text-secondary text-12">
                {t("pa_rs_old_date")} <b className="text-dark">{fmtDate(detail.plan_date)}</b> · {a.max_date ? <>{t("pa_rs_before_next")} <b className="text-dark">{fmtDate(a.max_date)}</b></> : t("pa_rs_last")} · {t("pa_rs_only_this")}
              </div>
            </div>
          ) : null}
          <label className="form-label text-12 text-secondary mb-1 mt-2">{t("wx_fu_note")}{currentReason?.requires_note ? " *" : ""}</label>
          <textarea className="form-control" rows={2} value={form.note} placeholder={t("pa_note_ph")} onChange={(e) => setForm({ note: e.target.value })} data-testid="pa-note" />
          {form_error ? <div className="mt-1 text-danger text-12" data-testid="pa-error">{form_error}</div> : null}
          <div className="d-flex justify-content-end mt-3">
            <button type="button" className="btn btn-primary px-4 py-2 fw-bold rounded-3" disabled={saving} onClick={this.Submit} data-testid="pa-submit">
              {form.action === "wo" ? `${t("pa_create_wo")} →` : form.action === "rs" ? t("pa_rs_save") : t("save")}
            </button>
          </div>
        </div>
      </>
    );
  }

  renderDetailModal() {
    const { detail } = this.state;
    const cls = detail ? BUCKET_CLASS[detail.bucket] : "";
    const done = detail?.state === "done";
    const colors = done ? BANNER_COLORS.done : BANNER_COLORS[cls] || BANNER_COLORS.plan;
    let banner = "";
    if (detail) {
      if (done) banner = `✅ ${t("pa_d_done")}`;
      else if (detail.days_left < 0) banner = `⛔ ${fill(t("pa_d_overdue"), { n: -detail.days_left })} · ${detail.state === "wo_overdue" ? t("pa_d_wo_open") : t("pa_state_no_wo")}`;
      else if (detail.bucket) banner = `⏳ ${fill(t("pa_d_left"), { n: detail.days_left })}${detail.state === "wo_created" ? ` · ${t("pa_d_stopped")}` : ""}`;
      else banner = `📅 ${fill(t("pa_d_far"), { n: detail.days_left })}`;
    }
    const occurrences = detail?.occurrences || [];
    const logs = detail?.postpone_logs || [];
    const alerts = detail?.alerts || [];
    const kv = detail
      ? [
          [t("pa_col_asset"), `${detail.asset_full?.name || detail.asset?.name || "-"}${detail.asset_full?.code ? ` (${detail.asset_full.code})` : ""}`],
          [t("wx_d_customer"), detail.customer_name],
          [t("wx_d_location"), detail.location],
          [t("pa_col_freq"), detail.frequency],
          [t("pa_d_template"), detail.checklist_template],
          [t("pa_col_tech"), detail.technician?.name],
          [t("pa_col_plan_date"), this.renderPlanDate(detail)],
          [t("pa_col_state"), this.renderState(detail)],
          [t("wx_col_last_alert"), this.renderLastAlert(detail)],
        ]
      : [];

    return (
      <Modal show={!!detail} onHide={this.CloseDetail} centered size="lg" scrollable contentClassName="border-0 rounded-4 shadow-lg" data-testid="pa-drawer">
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
          {detail ? (
            <div>
              <div className="text-secondary text-12">{t("pa_title_short")} · {[detail.bu_code || detail.department?.code, detail.bu_label || detail.department?.name].filter(Boolean).join(" – ")} · {fill(t("pa_occurrence"), { n: detail.occurrence_no, total: detail.occurrence_total })}</div>
              <h5 className="fw-bold mb-0 text-dark" data-testid="pa-detail-plan">{detail.plan_code || detail.asset?.name || detail.asset?.code}</h5>
            </div>
          ) : null}
        </Modal.Header>
        <Modal.Body className="p-4 bg-white">
          {detail ? (
            <>
              <div className="rounded-3 p-3 mb-4 fw-semibold text-14" style={{ background: colors[0], color: colors[1] }}>
                {banner} · {t("pa_col_plan_date")} {fmtDate(detail.plan_date)}
              </div>

              <div className="row g-3 text-14 mb-4">
                {kv.map(([label, value]) => (
                  <div className="col-md-6" key={label}>
                    <div className="text-secondary text-12">{label}</div>
                    <div className="text-dark text-break">{value || "-"}</div>
                  </div>
                ))}
              </div>

              {this.renderActions()}

              <div className="text-14 fw-bold text-dark mb-2">🗂️ {t("pa_log_title")} ({formatNumber(logs.length)})</div>
              <div className="table-responsive border rounded-3 mb-4">
                <table className="table table-hover align-middle mb-0">
                  <thead>
                    <tr className="text-dark fw-bold text-12 border-bottom border-light">
                      <th className="py-2 border-0">{t("fa_log_at")}</th>
                      <th className="py-2 border-0">{t("pa_log_by")}</th>
                      <th className="py-2 border-0">{t("pa_log_dates")}</th>
                      <th className="py-2 border-0">{t("pa_rs_reason")}</th>
                      <th className="py-2 border-0">{t("wx_fu_note")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!logs.length ? (
                      <tr><td colSpan={5} className="text-secondary text-12">{t("pa_log_none")}</td></tr>
                    ) : logs.map((l) => (
                      <tr key={l.uid} className="text-14 text-dark">
                        <td>{fmtDateTime(l.created_at)}</td>
                        <td>{l.created_by_name || "-"}</td>
                        <td className="text-nowrap">{fmtDate(l.old_date)} → <b>{fmtDate(l.new_date)}</b></td>
                        <td>{l.reason_label}</td>
                        <td className="text-break">{l.note || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="text-14 fw-bold text-dark mb-2">📅 {t("pa_occ_title")}</div>
              <div className="table-responsive border rounded-3 mb-4">
                <table className="table align-middle mb-0">
                  <thead>
                    <tr className="text-dark fw-bold text-12 border-bottom border-light">
                      <th className="py-2 border-0">{t("wx_h_no")}</th>
                      <th className="py-2 border-0">{t("pa_col_plan_date")}</th>
                      <th className="py-2 border-0">{t("pa_col_state")}</th>
                      <th className="py-2 border-0">WO</th>
                    </tr>
                  </thead>
                  <tbody>
                    {occurrences.map((o) => (
                      <tr key={o.wo_uid} className="text-14 text-dark" style={o.is_current ? { background: "#E8EDFF" } : undefined}>
                        <td>
                          {o.occurrence_no}
                          {o.is_current ? <span className="text-12 fw-semibold text-primary bg-white px-2 py-1 rounded-pill ms-1">{t("pa_occ_current")}</span> : null}
                        </td>
                        <td>
                          {o.original_date && o.original_date !== o.plan_date ? <div className="wx-strike text-12">{fmtDate(o.original_date)}</div> : null}
                          {fmtDate(o.plan_date)}
                          {o.postpone_count > 0 ? <span className="text-12 fw-semibold wx-fu-warn ms-1">↻ {formatNumber(o.postpone_count)}</span> : null}
                        </td>
                        <td><span className={`fw-semibold ${STATE_CLASS[o.state] || ""}`}>{o.state_label}</span></td>
                        <td>{o.work_order_number || "-"}{o.work_order_status_label ? <div className="text-secondary text-12">{o.work_order_status_label}</div> : null}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="text-14 fw-bold text-dark mb-2">📨 {t("pa_alert_history")}</div>
              <div className="wx-timeline mb-4">
                {!alerts.length ? <div className="it text-secondary">{t("wx_alert_none")}</div> : null}
                {alerts.map((a, i) => (
                  <div className="it text-dark" key={i}>
                    <b>{fmtDateTime(a.sent_at)}</b> — {fill(t("wx_alert_item"), { b: a.bucket })}
                  </div>
                ))}
                {detail.alert_mode === "repeat" ? <div className="it wx-fu-ovd fw-semibold">{t("pa_alert_repeat")}</div> : null}
              </div>

              {detail.data_as_of ? <div className="text-secondary text-12 mb-3" data-testid="pa-data-as-of">{t("wx_as_of")} {fmtDateTime(detail.data_as_of)}</div> : null}
              <div className="d-flex justify-content-end flex-wrap gap-2">
                {detail.plan_uid ? <a className="btn btn-white border px-3 py-2 rounded-3 fw-bold" href={`/ad/inspection-plan?uid=${encodeURIComponent(detail.plan_uid)}`} data-testid="pa-open-plan">{t("pa_open_plan")}</a> : null}
                {detail.asset_uid ? <a className="btn btn-white border px-3 py-2 rounded-3 fw-bold" href={`/ad/assets?uid=${encodeURIComponent(detail.asset_uid)}`} data-testid="pa-open-asset">{t("pa_open_asset")}</a> : null}
              </div>
            </>
          ) : null}
        </Modal.Body>
      </Modal>
    );
  }

  render() {
    const { view, filter_bu, filter_customer_uid, filter_status, filter_frequency, filter_technician_uid, filter_q, meta, count, page, rows, loaded, forbidden } = this.state;
    const customers = meta?.customer_options || [];
    const frequencies = meta?.frequency_options || [];
    const technicians = meta?.technician_options || [];
    const dq = meta?.data_quality;
    const statusOptions = STATUS_FILTERS.map((s) => ({ value: s, label: t(`pa_f_${s}`) }));

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("pa_title")}</h3>
              <div className="text-secondary text-14">{t("pa_desc")}{meta?.as_of ? ` · ${t("wx_as_of")} ${fmtDate(meta.as_of)}` : ""}</div>
            </div>
            <div className="d-flex flex-wrap gap-2 align-items-center">
              <div className="btn-group wx-view-toggle" role="group" data-testid="pa-view-toggle">
                <button type="button" className={`btn btn-white border px-3 py-2 fw-bold ${view === "list" ? "on" : ""}`} onClick={() => this.SetView("list")} data-testid="pa-view-list">{t("pa_view_list")}</button>
                <button type="button" className={`btn btn-white border px-3 py-2 fw-bold ${view === "cal" ? "on" : ""}`} onClick={() => this.SetView("cal")} data-testid="pa-view-cal">{t("pa_view_cal")}</button>
              </div>
              {this.canExport && !forbidden ? (
                <button type="button" className="btn btn-white border px-3 py-2 fw-bold rounded-3" onClick={this.Export} disabled={!rows.length} data-testid="pa-export-btn">⬇ {t("wx_export")}</button>
              ) : null}
            </div>
          </div>

          <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
            <div className="row g-3 align-items-end">
              <div className="col-md-3" data-testid="pa-f-bu">
                <label className="form-label text-12 text-secondary mb-1">{t("department")}</label>
                <Select
                  className="form-control w-100"
                  options={departmentFilterOptions(meta, filter_bu, t("wx_f_all_departments"))}
                  value={departmentFilterValue(this.state)}
                  onChange={(v) => this.SetFilter(departmentFilterPatch(v))}
                  placeholder={t("wx_f_all_departments")}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label text-12 text-secondary mb-1">{t("wx_d_customer")}</label>
                <Select
                  className="form-control w-100"
                  options={[{ value: "", label: t("pa_f_customer_all") }, ...customers.map((c) => ({ value: c.uid, label: c.name }))]}
                  value={filter_customer_uid}
                  onChange={(v) => this.SetFilter({ filter_customer_uid: v || "" })}
                  placeholder={t("pa_f_customer_all")}
                />
              </div>
              <div className="col-md-3" data-testid="pa-f-status">
                <label className="form-label text-12 text-secondary mb-1">{t("pa_col_state")}</label>
                <Select
                  className="form-control w-100"
                  options={statusOptions}
                  value={filter_status}
                  onChange={(v) => this.SetFilter({ filter_status: v || "open" })}
                  placeholder={t("pa_f_open")}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label text-12 text-secondary mb-1">{t("pa_col_freq")}</label>
                <Select
                  className="form-control w-100"
                  options={[{ value: "", label: t("pa_f_freq_all") }, ...frequencies.map((f) => ({ value: f, label: f }))]}
                  value={filter_frequency}
                  onChange={(v) => this.SetFilter({ filter_frequency: v || "" })}
                  placeholder={t("pa_f_freq_all")}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label text-12 text-secondary mb-1">{t("pa_f_tech")}</label>
                <Select
                  className="form-control w-100"
                  options={[{ value: "", label: t("all") }, ...technicians.map((tc) => ({ value: tc.uid, label: tc.name }))]}
                  value={filter_technician_uid}
                  onChange={(v) => this.SetFilter({ filter_technician_uid: v || "" })}
                  placeholder={t("all")}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label text-12 text-secondary mb-1">{t("wx_f_search")}</label>
                <input type="text" className="form-control" value={filter_q} placeholder={t("pa_f_search_ph")} onChange={(e) => this.SetQ(e.target.value)} />
              </div>
              <div className="col-md-3 d-flex justify-content-end">
                <ClearFilterButton onClick={this.ResetFilter} />
              </div>
            </div>
          </div>

          {forbidden ? (
            <div className="bg-white rounded-4 shadow-sm p-5 mb-4 text-center" data-testid="pa-forbidden">
              <h4 className="fw-bold text-dark">{forbidden}</h4>
              <p className="text-secondary text-14 mb-3">{t("wx_no_permission_hint")}</p>
              <button type="button" className="btn btn-primary px-4 py-2 fw-bold rounded-3" onClick={this.ResetFilter}>{t("wx_f_all_departments")}</button>
            </div>
          ) : (
            <>
              {dq && dq.excluded_total > 0 ? (
                <div className="alert alert-warning text-14 py-2 mb-4" data-testid="pa-dq">
                  {fill(t("pa_dq"), { n: formatNumber(dq.excluded_total), a: formatNumber(dq.missing_asset ?? 0), b: formatNumber(dq.missing_department ?? 0) })}
                </div>
              ) : null}

              {this.renderKpi()}

              {view === "cal" ? this.renderCalendar() : (
                <>
                  <div className="bg-white rounded-4 shadow-sm mb-4 overflow-hidden">
                    <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 px-4 pt-3 text-12 text-secondary">
                      <span>
                        {fill(t("pa_shown"), { n: formatNumber(count) })}
                        {meta?.overdue_count ? (
                          <>
                            {" · "}
                            <button type="button" className="btn btn-link p-0 text-12 fw-semibold align-baseline wx-fu-ovd" onClick={() => this.SetFilter({ filter_status: "open", filter_bucket: "ovd" })} data-testid="pa-overdue-link">⛔ {fill(t("pa_overdue_link"), { n: meta.overdue_count })}</button>
                          </>
                        ) : null}
                      </span>
                      <span>{t("pa_sort_hint")}</span>
                    </div>
                    {loaded ? this.renderTable() : null}
                  </div>

                  <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12">
                    <div>
                      {t("showing")} {count ? formatNumber((page - 1) * PAGE_SIZE + 1) : 0}-{formatNumber((page - 1) * PAGE_SIZE + rows.length)} {t("of")} {formatNumber(count)}
                    </div>
                    <Pagination className="mb-0" count={Math.ceil(count / PAGE_SIZE) || 1} page={page} showFirstButton={false} showLastButton={false} onChange={(_, next) => this.Get(next)} />
                  </div>
                </>
              )}
            </>
          )}
        </div>

        {this.renderDetailModal()}
      </div>
    );
  }
}
